import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'werkwijze',
    templateUrl: 'werkwijze.html'
})
export class Werkwijze implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/werkwijze/werkwijze.ts